import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiExternalLink, FiCheckCircle } = FiIcons;

const SocialMediaSection = ({ socialMedia }) => {
  const platforms = [
    { key: 'linkedin', name: 'LinkedIn', color: 'text-blue-400', bgColor: 'bg-blue-500/20' },
    { key: 'twitter', name: 'Twitter/X', color: 'text-sky-400', bgColor: 'bg-sky-500/20' },
    { key: 'facebook', name: 'Facebook', color: 'text-blue-500', bgColor: 'bg-blue-600/20' },
    { key: 'instagram', name: 'Instagram', color: 'text-pink-400', bgColor: 'bg-pink-500/20' },
    { key: 'tiktok', name: 'TikTok', color: 'text-black dark:text-white', bgColor: 'bg-gray-800/20 dark:bg-white/20' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.25 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={FiUsers} className="text-2xl text-purple-400" />
        <h3 className="text-2xl font-bold text-white">👤 SOCIAL MEDIA FOOTPRINT</h3>
        <span className="text-purple-300 text-sm ml-auto">
          {Object.keys(socialMedia).length} profile{Object.keys(socialMedia).length !== 1 ? 's' : ''} found
        </span>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {platforms.map((platform, index) => {
          const data = socialMedia[platform.key];
          return (
            <motion.div
              key={platform.key}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-black/30 rounded-lg p-6 border border-purple-500/20"
            >
              <div className="flex items-center space-x-3 mb-4">
                <div className={`p-2 rounded-lg ${platform.bgColor}`}>
                  <SafeIcon icon={FiUsers} className={`text-lg ${platform.color}`} />
                </div>
                <h4 className="text-lg font-semibold text-white">{platform.name}</h4>
              </div>
              
              {data ? (
                <>
                  <div className="mb-3">
                    <a 
                      href={data.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-blue-400 hover:text-blue-300 text-sm flex items-center space-x-2"
                    >
                      <span className="truncate">{data.link}</span>
                      <SafeIcon icon={FiExternalLink} className="flex-shrink-0" />
                    </a>
                  </div>
                  
                  {data.title && (
                    <p className="text-white text-sm mb-2 font-medium">
                      {data.title}
                    </p>
                  )}
                  
                  {data.snippet && (
                    <p className="text-purple-300 text-sm mb-3 line-clamp-2">
                      {data.snippet}
                    </p>
                  )}
                  
                  {data.currentRole && (
                    <p className="text-white text-sm mb-2">
                      <strong>Role:</strong> {data.currentRole}
                    </p>
                  )}
                  
                  {data.education && (
                    <p className="text-white text-sm mb-3">
                      <strong>Education:</strong> {data.education}
                    </p>
                  )}
                  
                  {data.indicators && (
                    <div className="space-y-2">
                      <p className="text-sm font-medium text-purple-300">Indicators:</p>
                      {data.indicators.map((indicator, idx) => (
                        <div key={idx} className="flex items-center space-x-2">
                          <SafeIcon icon={FiCheckCircle} className="text-green-400 text-xs" />
                          <span className="text-sm text-green-300">{indicator}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-4">
                  <p className="text-purple-400 text-sm">No profile detected</p>
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default SocialMediaSection;